import { createContext } from "react";
import { CameraContextType } from "./types";

export const CameraContext = createContext<CameraContextType | undefined>(
  undefined
);
